import { render } from "./OtpSetupCode.vue?vue&type=template&id=c78d62ba"
import script from "./OtpSetupCode.vue?vue&type=script&lang=js"
export * from "./OtpSetupCode.vue?vue&type=script&lang=js"

import "./OtpSetupCode.vue?vue&type=style&index=0&id=c78d62ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__